import {
  DatePicker,
  type DatePickerProps,
} from "@repo/ui/components/Base/DatePicker";
import { useFormikContext } from "formik";

interface FormikDatePickerProps extends Omit<DatePickerProps, "onDateChange"> {
  label: string;
  name: string;
}

export const FormikDatePicker = (props: FormikDatePickerProps) => {
  const { setFieldValue } = useFormikContext();
  return (
    <DatePicker
      {...props}
      onDateChange={(date) => setFieldValue(props.name, date)}
    />
  );
};
